import {useMemo} from 'react';
import type {Data, PartYear} from 'schemaDefinition/types';
import {getDateRange} from 'schemaDefinition/functions';

export const useYearRange = (
  part: PartYear,
  valuePath: string,
  scope?: Data,
  globalScope?: Data,
  relatedScope?: Data,
): {
  minValue: number | undefined;
  maxValue: number | undefined;
} =>
  useMemo(() => {
    const dateRange = getDateRange(part.validation, {
      valuePath,
      localScope: scope,
      globalScope,
      relatedScope,
    });
    return {
      minValue:
        dateRange.minValue === undefined ? undefined : dateRange.minValue.year,
      maxValue:
        dateRange.maxValue === undefined ? undefined : dateRange.maxValue.year,
    };
  }, [globalScope, part.validation, relatedScope, scope, valuePath]);
